module.exports = __webpack_public_path__ + "img/9.20941074.jpg";